
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";
import filters from "@/filters";
import toast from "@/functions/toast.function";

@Component({
  components: {},
  filters,
})
export default class ModalConfirmEnd extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionJobFairTurnOff", { namespace: "job" })
  private actionJobFairTurnOff: any;

  // STATE
  @State("job_fair", { namespace: "job" })
  private job_fair: any;

  // PROP
  @Prop({ default: false })
  private isShow: boolean;

  /* INITIALIZATION */

  private showUploadLogo: boolean = false;
  private showUploadBanner: boolean = false;
  private bannerName: string = "";

  private get differentEndDay() {
    const now = new Date();
    const period_end = new Date(this.job_fair.period_end);
    now.setHours(0, 0, 0);
    period_end.setHours(0, 0, 0);
    const diff = period_end.getTime() - now.getTime();
    return Math.ceil(diff / (1000 * 3600 * 24));
  }

  constructor() {
    super();
  }

  /* WATCH */

  /* LIFECYCLE */

  /* METHODS */

  private clickEnd() {
    this.actionJobFairTurnOff({
      params: null,
      success: (response: any) => {
        // TODO
        this.$emit("update:isStatus", false);
        this.$emit("update:isShow", false);
        this.$emit("on-success");
        this.$router.push({ name: "jobsfair", params: { from: "endjobfair" } });
      },
      fail: (response: any) => {
        // TODO
      },
    });
  }
}
